import {RouteLocationNormalized, RouterView} from "vue-router";
import {useServiceStore} from "@/stores/service/service";
import {IBreadcrumbMeta} from "cdp-fe-commons-layout";

const Services = () => import('@/views/services/Services.vue')
const RichiesteServices = () => import('@/views/services/RichiesteServices.vue')
const ServiceDetail = () => import('@/views/services/ServiceDetail.vue')
const RichiesteServiceDetail = () => import('@/views/services/RichiesteServiceDetail.vue')
const OnlineRequestForm = () => import('@/views/istanze/OnlineRequestForm.vue')

const servicesRoutes = [
    {
        path: 'servizi',
        name: 'Servizi',
        meta: {
            breadcrumb: {
                customName: "Istanze"
            } as IBreadcrumbMeta
        },
        component: RouterView,
        children: [
            {
                path: '',
                name: 'ListaServizi',
                component: Services,
                meta: {
                    breadcrumb: {
                        exclude: true
                    } as IBreadcrumbMeta,
                },
            },
            {
                path: 'dettaglio/:codiceCatalogo',
                name: 'ServiziDetail',
                component: RouterView,
                meta: {
                    breadcrumb: {
                        customNameBeforeResolve: (to: RouteLocationNormalized) => {
                            const codiceCatalogo = to.params.codiceCatalogo as string ?? '';
                            const serviceStore = useServiceStore();
                            return serviceStore.getServiceTitle(codiceCatalogo);
                        },
                    } as IBreadcrumbMeta,
                },
                children: [
                    {
                        path: '',
                        name: 'Servizio',
                        component: ServiceDetail,
                        meta: {breadcrumb: {exclude: true} as IBreadcrumbMeta},
                    },
                    {
                        path: 'richiestaonline/:codiceIstanza',
                        name: "Compila richiesta da servizi",
                        meta: {
                            requiresAuth: true,
                            breadcrumb: {
                                customName: "Compila Online"
                            } as IBreadcrumbMeta
                        },
                        component: OnlineRequestForm,
                    }
                ]
            },
        ]
    },
    {
        path: 'servizi-interni/:token?',
        name: 'Servizi Interni',
        meta: {
            breadcrumb: {
                customName: "Richieste"
            } as IBreadcrumbMeta
        },
        component: RouterView,
        props: true,
        children: [
            {
                path: '',
                name: 'ListaServiziInterni',
                component: RichiesteServices,
                meta: {
                    breadcrumb: {
                        exclude: true
                    } as IBreadcrumbMeta,
                },
            },
            {
                path: 'dettaglio/:codiceCatalogo',
                name: 'ServiziInterniDetail',
                component: RouterView,
                meta: {
                    breadcrumb: {
                        customNameBeforeResolve: (to: RouteLocationNormalized) => {
                            const codiceCatalogo = to.params.codiceCatalogo as string ?? '';
                            const serviceStore = useServiceStore();
                            return serviceStore.getServiceTitle(codiceCatalogo);
                        },
                    } as IBreadcrumbMeta,
                },
                children: [
                    {
                        path: '',
                        name: 'ServizioInterno',
                        component: RichiesteServiceDetail,
                        meta: {breadcrumb: {exclude: true} as IBreadcrumbMeta},
                    },
                    {
                        path: 'richiestaonline/:codiceIstanza',
                        name: "Compila richiesta",
                        meta: {
                            requiresAuth: true,
                            breadcrumb: {
                                customName: "Compila Online"
                            } as IBreadcrumbMeta
                        },
                        component: OnlineRequestForm,
                    }
                ]
            },
        ]
    },
];

export default servicesRoutes;
